var exports = {
  "k": "xa15a2ab7--6eb5a8--container",
};

module.exports = exports;
